module.exports = __webpack_public_path__ + "static/media/about.df52735a.jpg";